import styled from 'styled-components'

export const List = styled.ul<{ $scrollable?: boolean }>(({ theme, $scrollable }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['4'],
  listStyle: 'none',
  margin: 0,
  maxHeight: $scrollable ? '32rem' : undefined,
  maxWidth: '32rem',
  overflowY: $scrollable ? 'auto' : undefined,
  padding: 0,
  paddingRight: $scrollable ? theme.space['8'] : 0,
  scrollbarColor: $scrollable ? `${theme.colors.gray600} transparent` : undefined,
  scrollbarWidth: $scrollable ? 'thin' : undefined,
  textAlign: 'left',
}))

export const More = styled.li(({ theme }) => ({
  '& a': {
    color: 'inherit',
    font: 'inherit',
    justifyContent: 'flex-start',
    padding: 0,
  },
  '& a:hover': {
    color: theme.colors.white,
    textDecoration: 'underline',
  },
  color: theme.colors.gray400,
  fontStyle: 'italic',
}))

// Note: underlined on hover so a count that opens on click reads as clickable
export const ClickableText = styled.span({
  '&:hover': {
    textDecoration: 'underline',
  },
  cursor: 'pointer',
})

export const MoreButton = styled.button({
  '&:hover': {
    color: 'inherit',
    textDecoration: 'underline',
  },
  background: 'none',
  border: 0,
  color: 'inherit',
  cursor: 'pointer',
  font: 'inherit',
  fontStyle: 'italic',
  padding: 0,
})
